import { defineMessages } from 'react-intl'

// E8 F8-1 LoginPage strings.
const messages = defineMessages({
  title: {
    id: 'login.title',
    defaultMessage: 'Sign in',
  },
  titleWithWorkspace: {
    id: 'login.titleWithWorkspace',
    defaultMessage: 'Sign in to {workspace}',
  },
  subtitle: {
    id: 'login.subtitle',
    defaultMessage: 'Continue to your LogikSpark workspace.',
  },
  signInButton: {
    id: 'login.signInButton',
    defaultMessage: 'Sign in',
  },
  // E12 F12-7 — one actionable button per federation provider; clicking routes to Entra with the provider's
  // domain_hint so External ID sends the user to that upstream IdP.
  signInWithProvider: {
    id: 'login.signInWithProvider',
    defaultMessage: 'Sign in with {provider}',
  },
  // E12 F12-6 — caution beside a provider that has a domain awaiting (re-)verification.
  providerUnverifiedCaution: {
    id: 'login.providerUnverifiedCaution',
    defaultMessage: 'Some domains for this provider are awaiting verification.',
  },
  // Shown when AuthCallbackPage returns here after a failed interactive sign-in (?error). Generic by design:
  // the B2C-era "invalid subdomain" distinction is moot post-Entra-cutover, and Entra surfaces specifics on
  // its own page.
  signInError: {
    id: 'login.signInError',
    defaultMessage: 'Sign-in did not complete. Please try again.',
  },
  // 8.1.3 — browser tab title, hydrated from the Tenant branding (display name).
  documentTitle: {
    id: 'login.documentTitle',
    defaultMessage: '{workspace} — Sign in',
  },
  logoAlt: {
    id: 'login.logoAlt',
    defaultMessage: '{workspace} logo',
  },
})

export default messages
